import React from 'react';
import { AVAILABLE, COMPLETED } from '../../../../../constants/components/pages/challenges/statuses';
import ChallengeSectionButton from './ChallengeSectionButton';
import ChallengeAvailableInfo from './ChallengeAvailableInfo';
import { safeHTML } from '../../../../../utils/safeHTML';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';

const ChallengeSectionComponents = {
  [AVAILABLE]: ChallengeAvailableInfo,
  [COMPLETED]: ChallengeSectionButton,
};

export default function ChallengeSectionInfo({ status, challengeData }) {
  const Component = ChallengeSectionComponents[status] ?? 'div';
  const callbacks = useApplicationCallbacks();

  return (
    <div className={'challenges__section-info'}>
      <h2 className={'challenges__section-title'}>{safeHTML(challengeData?.text)}</h2>
      {challengeData?.description && (
        <div className={'challenges__section-subtitle'}>{safeHTML(challengeData?.description)}</div>
      )}
      <Component challengeData={challengeData} callbacks={callbacks} />
    </div>
  );
}
